import { OnInit } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
import get from 'lodash.get';
import { MqService } from 'src/app/service/mq.service';
import { ThumbnailBuilderService } from './service/thumbnail-builder.service';
var VideoPanelComponent = /** @class */ (function () {
    function VideoPanelComponent(thumbnailBuilder, mq) {
        this.thumbnailBuilder = thumbnailBuilder;
        this.mq = mq;
        this.isShow = false;
    }
    Object.defineProperty(VideoPanelComponent.prototype, "hostClasses", {
        get: function () {
            return resolveThemeCssClass(this.data.panelSettings);
        },
        enumerable: true,
        configurable: true
    });
    VideoPanelComponent.prototype.ngOnInit = function () {
        this.mq.mobileDesktop(this.mobile.bind(this), this.desktop.bind(this));
        this.showFullSize = this.data.showFullSize.value;
    };
    VideoPanelComponent.prototype.mobile = function () {
        this.videoData = this.prepareVm(get(this.data, "video.value.mobile"));
    };
    VideoPanelComponent.prototype.desktop = function () {
        this.videoData = this.prepareVm(get(this.data, "video.value.desktop"));
    };
    VideoPanelComponent.prototype.open = function () {
        this.isShow = true;
    };
    VideoPanelComponent.prototype.close = function () {
        this.isShow = false;
    };
    VideoPanelComponent.prototype.prepareVm = function (data) {
        if (!data)
            return null;
        return {
            thumbnail: this.thumbnailBuilder.create(data.thumbnail),
            title: this.data.title,
            description: this.data.description,
            params: "?controls=1&muted=0&autoplay=1&showinfo=0",
            video: {
                url: data.url,
                type: data.type,
            },
            videoTitle: data.title,
        };
    };
    return VideoPanelComponent;
}());
export { VideoPanelComponent };
